
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/thread/designing-platforms-for-developers",
      function () {
        return require("private-next-pages/thread/designing-platforms-for-developers.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/thread/designing-platforms-for-developers"])
      });
    }
  